module.exports = require("@swa-ui/itinerary/src/SeatAssignment/SeatAssignment.module.scss");